import { render, staticRenderFns } from "./SustainabilityQuestions.vue?vue&type=template&id=25b130f2&scoped=true&"
import script from "./SustainabilityQuestions.vue?vue&type=script&lang=ts&"
export * from "./SustainabilityQuestions.vue?vue&type=script&lang=ts&"
import style0 from "./SustainabilityQuestions.vue?vue&type=style&index=0&id=25b130f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b130f2",
  null
  
)

export default component.exports